// Rótulos do perfil profissional do professor. A API guarda esses campos como
// chaves de enum (e, no caso dos anos de experiência, como o código inteiro do
// enum, não a quantidade), então tudo que for exibido ao aluno passa por aqui.
// Os textos são os mesmos que o professor vê no cadastro (PartnerRegister.vue).
import i18n from "@/plugins/i18n";

// ATENÇÃO: o valor é o código do enum YearsOfExperience, não o número de anos.
// `3` significa "6-10 anos" — imprimir o número cru engana quem lê.
// Rotulo traduzido de uma chave de enum (enums.<group>.<key>); "" se nao houver.
const enumText = (group, key) => {
  const path = `enums.${group}.${key}`;
  return i18n.te(path, "pt") ? i18n.t(path) : "";
};

// Os campos multivalorados chegam como CSV de chaves ("conversation,grammar").
// Devolve uma lista de rótulos; chave desconhecida passa direto, para nunca
// sumir informação da tela.
const toLabelList = (value, group) =>
  String(value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => enumText(group, item) || item);

export function yearsOfExperienceLabel(value) {
  if (value === null || value === undefined || value === "") return "";
  return enumText("yearsOfExperience", Number(value));
}

export function academicFormationLabel(value) {
  if (value === null || value === undefined || value === "") return "";
  return enumText("academicFormation", Number(value));
}

export function specialityLabels(value) {
  return toLabelList(value, "speciality");
}

export function institutionLabels(value) {
  return toLabelList(value, "institution");
}

export function teachingAbroadLabels(value) {
  return toLabelList(value, "teachingAbroad");
}
